var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpinnerIcon = function SvgSpinnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.983 8.875c-.438 0-.804.32-.938.737a5.27 5.27 0 0 1-5.018 3.638c-2.91 0-5.27-2.35-5.27-5.25 0-2.604 1.903-4.765 4.399-5.179.477-.079.871-.463.871-.946 0-.483-.394-.88-.873-.821C3.685 1.482 1 4.429 1 8c0 3.866 3.146 7 7.027 7a7.026 7.026 0 0 0 6.774-5.129c.144-.52-.278-.996-.818-.996Z",
    fill: "currentColor"
  })));
};

export default SvgSpinnerIcon;